import { ApiAddress } from "./apis"
import { IPlanPermission } from "./plan-permission/plan-permission.service"
import request from "./request"

export enum PlanType {
  Free = 1,
  Drafter = 2,
  ProcessEngineer = 3
}

export interface Plan {
  id: number
  name: string
  type: PlanType
  price: number
  currency: string
  description: string
  billingFrequency: string
  permissions: Array<IPlanPermission>
  features: Array<{
    active: boolean
    description: string
  }>
}

export const getPlans = (): Promise<Plan[]> => {
  return request.get(ApiAddress.PLANS)
}

export const getCheckoutSession = (plan: Plan): Promise<any> => {
  return request.post(ApiAddress.CHECKOUT_SESSION, {'productName': plan.name, 'price': plan.price})
}

export const getPaymentStatus = (id: string): Promise<{success: boolean}> => {
  return request.get(ApiAddress.PAYMENT_STATUS, {params: {id}}).catch(() => Promise.resolve({success: false} as any))
}